import { createAction } from '@reduxjs/toolkit';

export const addPartnerUrl = createAction<string>('streams/addPartnerUrl');
